import { render } from "./Calendar.vue?vue&type=template&id=04faedb3"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"
script.render = render

export default script